import { Button, Modal } from '@bfe/moly';
import React from 'react';

import { useI18nContext } from '@/i18n/I18n';

const GuideRegister = ({ onCancel }: { onCancel: () => void }) => {
  const [$t] = useI18nContext();
  const toChangePwd = () => {
    const url = window.location.origin + '/app/user/security/modify-password';
    localStorage.setItem('guide_edit_pwd2', '0');
    window.location.href = url;
  };
  return (
    <Modal
      footer={false}
      open
      size="small"
      type="alert"
      onCancel={() => {
        onCancel?.();
        localStorage.setItem('guide_edit_pwd2', '0');
      }}
    >
      <div style={{ marginTop: '12px', color: 'var(--bds-gray-t1-title)' }}>
        {$t('bySafeLoginPwdDesc')}
      </div>
      <Button
        style={{ width: '100%', marginTop: '24px' }}
        variant="primary"
        onClick={toChangePwd}
      >
        {$t('Change Login Password')}
      </Button>
    </Modal>
  );
};

export default GuideRegister;
